

















import Vue from "vue";
export default Vue.extend({
    name: "UtdsHeader",
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: String,
    },
    created() {
        if (this.$vuetify.breakpoint.mobile) {
            document.documentElement.style.setProperty(
                "--header-icons-margin-left",
                "0px"
            );
        }
    },
});
